export default __webpack_public_path__ + "static/media/btn-pause-rounded.cd38c902.svg";